// sidebarBanner.jsx
import React from "react";

const galleryImages = [
  "https://kryzen.com/wp-content/uploads/2022/02/18.png",
  "https://kryzen.com/wp-content/uploads/2024/02/1.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/22.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/33.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/7.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/25.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/36.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/5.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/27.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/17.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/14.jpg",
  "https://kryzen.com/wp-content/uploads/2024/02/13.jpg",
];

// ------------------ AGRI SUBSIDY ------------------
export const AgriSubsidyCard = () => {
  return (
    <div className="p-3 mb-4 border rounded-4 shadow-sm bg-white mt-4">
      <h5 className="fw-bold">Check Agriculture Subsidy</h5>
      <p className="text-secondary">
        Check latest government subsidies and eligibility for hydroponics and
        modern farming.
      </p>

      <button
        onClick={() =>
          (window.location.href =
            "https://alpha.kryzen.com/agri-subsidy?theme=light")
        }
        className="btn btn-success w-100 rounded-3"
      >
        Check Subsidy
      </button>
    </div>
  );
};

// ------------------ HYDROPONIC WEBINAR ------------------
export const HydroponicWebinarCard = () => {
  return (
    <div className="p-3 mb-4 border rounded-4 shadow-sm bg-white">
      <h5 className="fw-bold">Hydroponics Webinar</h5>
      <p className="text-secondary">
        Join our expert-led hydroponics webinar and learn modern farming
        techniques.
      </p>

      <button
        onClick={() =>
          (window.location.href =
            "https://alpha.kryzen.com/hydroponic-webinar?theme=light")
        }
        className="btn btn-primary w-100 rounded-3"
      >
        Register Now
      </button>
    </div>
  );
};

// ------------------ FARM SETUP ------------------
export const FarmSetupCard = () => {
  return (
    <div className="p-3 mb-4 border rounded-4 shadow-sm bg-white">
      <h5 className="fw-bold">Hydroponics Farm Setup</h5>
      <p className="text-secondary">
        Get consultation, project report, and complete support for your
        hydroponics farm.
      </p>

      <button
        onClick={() =>
          (window.location.href = "https://kryzen.com/kryzen-for-mega-farming/")
        }
        className="btn btn-warning w-100 rounded-3"
      >
        Enquire Now
      </button>
    </div>
  );
};
export const SharkTankKryzenVideo = () => {
  return (
    <div className="p-3 mb-4 border rounded-4 shadow-sm bg-white mt-6">
      <h3 className=" mb-2">Kryzen Hydroponics on Shark Tank India</h3>
      <p className="text-secondary mb-3">
        Watch how Kryzen Biotech innovated hydroponics on Shark Tank India.
      </p>

      <div className="rounded-4 overflow-hidden mb-3">
        <img
          src="https://img.youtube.com/vi/ZUH8kaLNC-Q/maxresdefault.jpg"
          alt="Shark Tank India Kryzen"
          className="img-fluid"
        />
      </div>

      <button
        onClick={() =>
          window.open("https://www.youtube.com/watch?v=ZUH8kaLNC-Q", "_blank")
        }
        className="btn btn-danger w-100 rounded-3"
      >
        ▶ Watch on YouTube
      </button>
    </div>
  );
};

// Pick a random image each refresh
const randomImage =
  galleryImages[Math.floor(Math.random() * galleryImages.length)];

export const GalleryCard = () => {
  return (
    <div className="p-3 mb-4 border rounded-4 shadow-sm bg-white">
      <h5 className="fw-bold">Hydroponics Gallery</h5>
      <p className="text-secondary">
        Explore our hydroponics farms, systems, training sessions, and projects.
      </p>

      <div className="rounded-4 overflow-hidden mb-3">
        <img
          src={randomImage}
          alt="Kryzen Hydroponics Gallery"
          className="img-fluid"
        />
      </div>

      <button
        onClick={() => (window.location.href = "/gallery")}
        className="btn btn-dark w-100 rounded-3"
      >
        View Gallery
      </button>
    </div>
  );
};

export const GalleryCarouselCard = () => {
  return (
    <div className="p-3 mb-4 border rounded-4 shadow-sm bg-white">
      <h3 className="fw-bold mb-2">Hydroponics Gallery</h3>
      <p className="text-secondary mb-3">
        Explore our hydroponic farms, systems, training, and mega projects.
      </p>

      <div
        id="galleryCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner rounded-4 overflow-hidden">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img
                src={img}
                className="d-block w-100"
                alt={`Gallery ${index}`}
              />
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#galleryCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon"></span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#galleryCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>

      <button
        onClick={() => (window.location.href = "/gallery")}
        className="btn btn-dark w-100 rounded-3 mt-3"
      >
        View Full Gallery
      </button>
    </div>
  );
};
export const Adcards = () => {
  return (
    <div className="d-flex justify-content-space-between ">
      <div className="">
        <a href="https://kryzen.com/farm-training/">
          <img
            width={150}
            height={150}
            alt="farm training"
            src="https://res.cloudinary.com/dfhuelkzw/image/upload/v1763963968/Farm_Training_1_zhixdv.gif"
          />
        </a>
      </div>
      <div className="ms-2">
        <a href="https://kryzen.com/site-inspection-kit/">
          <img
            width={150}
            height={150}
            alt="Site Inspection"
            src="https://res.cloudinary.com/dfhuelkzw/image/upload/v1764412190/Farm_Training_3_wm0obs.gif"
          />
        </a>
      </div>
      <div className="ms-2">
        <a href="https://www.hydroponicmasterclass.com/">
          <img
            width={150}
            height={150}
            alt="Hydroponic masterclass"
            src="https://res.cloudinary.com/dfhuelkzw/image/upload/v1764237422/Farm_Training_2_zykuon.gif"
          />
        </a>
      </div>
    </div>
  );
};
